import { render } from "./zhenggaonews.vue?vue&type=template&id=be1e4222&scoped=true"
import script from "./zhenggaonews.vue?vue&type=script&lang=js"
export * from "./zhenggaonews.vue?vue&type=script&lang=js"

import "./zhenggaonews.vue?vue&type=style&index=0&id=be1e4222&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1e4222"]])

export default __exports__